import React from "react";

const SessionExpired = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-200 px-4">
      <div className="bg-white max-w-md w-full rounded-lg shadow-md p-8 text-center">
        <h1 className="text-2xl font-semibold text-gray-800 mb-4">
          Session has expired
        </h1>

        <p className="text-gray-600 text-sm mb-3">
          For privacy and data protection reasons, your profile link has
          expired.
        </p>

        <p className="text-gray-600 text-sm mb-4">
          🔗 Profile links remain active for{" "}
          <span className="font-medium">10 days</span> from the date of sharing.
          To request a new access link for the same profile, please:
        </p>

        <p className="text-gray-700 text-sm mb-2">
          WhatsApp us at:{" "}
          <span className="font-semibold">+91-9485 77 3355</span>
        </p>

        <p className="text-gray-500 text-sm mb-4">Or</p>

        <a
          href="https://wa.me/919485773355"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block bg-green  text-white px-6 py-2 rounded-md text-sm font-medium mb-6"
        >
          💬 Click to Chat
        </a>

        <p className="text-gray-600 text-sm mb-3">
          We'll be happy to re-share the profile link and assist you further.
        </p>

        <p className="text-gray-600 text-sm mb-4">
          For more details about our premium services, visit our official
          website:
        </p>

        <a
          href="https://www.vipmatrimonialservices.com"
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-600 text-sm hover:underline"
        >
          🌐 www.vipmatrimonialservices.com
        </a>

        <p className="text-gray-600 text-sm mt-6">
          If you have any questions, feel free to reach out. We're here to help!
        </p>

        <div className="border-t mt-6 pt-4 text-sm text-gray-500">
          Copyright © 2020
          <div className="text-blue-600 font-medium">
            VIP Matrimonial Services Pvt. Ltd.
          </div>
        </div>
      </div>
    </div>
  );
};

export default SessionExpired;
